<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm" *ngIf="UserModuleAccess==='Full'">
	<div class="row mb-2">
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="ng-autocomplete">
				<ng-autocomplete formControlName="Cat_id" id="Cat_id" [data]="categoryList"
					[searchKeyword]="'category_name'" placeholder="Category*" historyIdentifier="categoryList"
					[itemTemplate]="rankItemTemplate" [notFoundTemplate]="rankNotFoundTemplate"></ng-autocomplete>
				<ng-template #rankItemTemplate let-item>
					<a [innerHTML]="item.category_name"></a>
				</ng-template>
				<ng-template #rankNotFoundTemplate let-notFound>
					<div [innerHTML]="notFound"></div>
				</ng-template>
			</div>
			<!-- <ng-select [items]="categoryList" bindLabel="category_name" bindValue="cat_id" [clearable]="true"
				placeholder="Category*" id="Cat_id" formControlName="Cat_id" appearance="outline">
			</ng-select> -->
			<p *ngIf="showError('Cat_id')" class="text-danger">
				<span *ngIf="f.Cat_id.errors?.required">
					Required
				</span>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('acronym')}" id="acronym"
					formControlName="acronym" placeholder="">
				<label for="acronym">Acronym*</label>
			</div>
			<p *ngIf="showError('acronym')" class="text-danger">
				<span *ngIf="f.acronym.errors?.required">
					Required
				</span>
				<span *ngIf="f.acronym.errors?.incorrect">
					{{customError.acronym}}
				</span>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('scale_name')}" id="scale_name"
					formControlName="scale_name" placeholder="">
				<label for="scale_name">Scale Name*</label>
			</div>
			<p *ngIf="showError('scale_name')" class="text-danger">
				<span *ngIf="f.scale_name.errors?.required">
					Required
				</span>
				<span *ngIf="f.scale_name.errors?.incorrect">
					{{customError.scale_name}}
				</span>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<ng-select id="parent" [items]="scaleList" bindLabel="scale_name" bindValue="scale_id" [clearable]="true"
				placeholder="Parent Scale" formControlName="parent" appearance="outline">
			</ng-select>
			<p *ngIf="showError('parent')" class="text-danger">
				<span *ngIf="f.parent.errors?.incorrect">
					{{customError.parent}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<textarea class="form-control" [ngClass]="{'is-invalid':showError('description')}" id="description"
					formControlName="description" placeholder=""></textarea>
				<label for="description">Description</label>
			</div>
			<p *ngIf="showError('description')" class="text-danger">
				<span *ngIf="f.description.errors?.incorrect">
					{{customError.description}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th style="width: 5%;">#</th>
						<th style="width: 50%;">Question</th>
						<th style="width: 30%;">Condition</th>
						<th style="width: 10%;">Value</th>
						<th style="width: 5%;">Remove</th>
					</tr>
				</thead>
				<tbody>
					<tr formArrayName="questions" *ngFor="let creds of get_rows.controls; let i = index">
						<ng-container [formGroupName]="i">
							<td>{{i+1}}</td>
							<td>
								<ng-select [items]="questionList" bindLabel="question_name" bindValue="id"
									[clearable]="true" placeholder="Question" id="que{{i}}" formControlName="que"
									appearance="outline" groupBy="profileName">
									<ng-template ng-label-tmp let-item="item">
										{{item.question_name}}
									</ng-template>
									<ng-template ng-option-tmp let-item="item" let-search="searchTerm"
										let-index="index">
										<strong>{{item.profileName}}</strong>
										&nbsp;:&nbsp;
										{{item.question_name}}
									</ng-template>
								</ng-select>
								<p *ngIf="showError2(i,'que')" class="text-danger">
									<span *ngIf="creds.get('que')?.errors?.required">
										Required
									</span>
								</p>
							</td>
							<td>
								<mat-radio-group aria-label="Select an option" formControlName="condition"
									id="condition{{i}}">
									<mat-radio-button [name]="'condition'+i" ngDefaultControl [value]="'1'"
										[color]="'primary'">
										Yes(Very True)
									</mat-radio-button>
									<mat-radio-button [name]="'condition'+i" ngDefaultControl [value]="'3'"
										[color]="'primary'">
										Mainly True
									</mat-radio-button>
									<mat-radio-button [name]="'condition'+i" ngDefaultControl [value]="'2'"
										[color]="'primary'">
										Slightly True
									</mat-radio-button>
									<mat-radio-button [name]="'condition'+i" ngDefaultControl [value]="'0'"
										[color]="'primary'">
										No(False)
									</mat-radio-button>
								</mat-radio-group>
								<p *ngIf="showError2(i,'condition')" class="text-danger">
									<span *ngIf="creds.get('condition')?.errors?.required">
										Required
									</span>
								</p>
							</td>
							<td>
								<div class="form-floating">
									<input class="form-control" [ngClass]="{'is-invalid':showError2(i,'value')}"
										id="value{{i}}" formControlName="value" placeholder="">
									<label for="value">Value*</label>
								</div>
								<p *ngIf="showError2(i,'value')" class="text-danger">
									<span *ngIf="creds.get('value')?.errors?.required">
										Required
									</span>
								</p>
							</td>
							<td>
								<button type="button" (click)="deleteRow(i)" class="btn btn-sm btn-danger"
									matTooltip="Remove">
									<fa-icon [icon]="['fas', 'times']"></fa-icon>
								</button>
							</td>
						</ng-container>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="button" (click)="addRow()" class="btn btn-primary me-1">
				<fa-icon [icon]="['fas', 'plus']"></fa-icon>
				Add
			</button>
			<button type="submit" class="btn btn-success me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>